/**
 */
const flag = false
export default {
  /*
   * 统一log方法
   * */
  log (...msgs) {
    if (flag) return
    for (let msg of msgs) console.log('统一LOG:', msg)
  },
  logCord (...msgs) {
    if (flag) return
    let newMsg = ''
    for (let msg of msgs) {
      if (typeof msg === 'object') {
        newMsg += JSON.stringify(msg) + ' '
      } else {
        newMsg += msg + ' '
      }
    }
    console.log('统一LOG:', newMsg)
  },
  /**
   * 引用类型克隆
   */
  clone (obj) {
    if (typeof obj !== 'object') return obj
    let newObj = obj instanceof Array ? [] : {}
    for (let i in obj) {
      let val = obj[i]
      if (val instanceof Date) {
        newObj[i] = new Date(val.valueOf())
      } else if (!val) {
        newObj[i] = val
      } else {
        newObj[i] = typeof val === 'object' ? this.clone(val) : val
      }
    }
    return newObj
  },
  /**
   * 改变对象中某个值的key
   */
  replaceKey (obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey]
    delete obj[oldKey]
    return obj
  },
  /**
   * @param value
   * 如果是number类型: 大于等于 0 返回 true, 否则返回 false, NaN 也是返回 false
   * 如果是Array类型: 长度大于 0 返回 true, 否则返回 false
   * 如果是Date类型: 返回 if (value)
   * 如果是Object类型: 如果不为null且不为空对象(如:{}) 返回 true, 否则返回 false
   * @returns {boolean}
   */
  isNotEmpty (value) {
    if (value === null || value === undefined || value === '') return false
    if (typeof value === 'number') {
      if (value >= 0) return true
      else return false
    } else if (Array.isArray(value)) {
      return value.some(item => item != null)
    } else if (value instanceof Date) {
      if (value) return true
      else return false
    } else if (value instanceof Object) {
      if (Object.keys(value).length === 0) return false
      else return true
    } else if (value) return true
    else if (value) return true
    else false
  },
  /**
   * let els = this.$refs[formName].$el.elements
   * 表单原始值设置
   */
  setFormDefault (els) {
    for (let el of els) {
      let type = el.type
      if (type === 'checkbox' || type === 'radio') {
        el.defaultChecked = el.checked
      } else if (type === 'hidden' || type === 'password' ||
        type === 'text' || type === 'textarea') {
        el.defaultValue = el.value
      } else if (type === 'select-one' || type === 'select-multiple') {
        for (let opt of el.options) {
          opt.defaultSelected = opt.selected
        }
      }
    }
  },
  /**
   * let els = this.$refs[formName].$el.elements
   * 查表单值是否有改变
   */
  formIsChange (els) {
    for (let el of els) {
      let type = el.type
      if (type === 'checkbox' || type === 'radio') {
        if (el.checked !== el.defaultChecked) {
          this.logCord('表单值改变', el)
          return true
        }
      } else if (type === 'hidden' || type === 'password' ||
        type === 'text' || type === 'textarea') {
        if (el.value !== el.defaultValue) {
          this.logCord('表单值改变', el)
          return true
        }
      } else if (type === 'select-one' || type === 'select-multiple') {
        for (let opt of el.options) {
          if (opt.selected !== opt.defaultSelected) {
            this.logCord('表单值改变', el)
            return true
          }
        }
      }
    }
    return false
  },
  /**
   * 数组已知值，不知下标，删除元素
   * @param arr
   * @param val
   */
  arrDel (arr, val) {
    let i = arr.indexOf(val)
    if (i !== -1) {
      arr.splice(i, 1)
    }
    return arr
  },
  /**
   * 替换空值，并可设置一个默认值
   * @param val
   * @param defaultVal
   * @returns {*}
   */
  ridEmpty (val, defaultVal) {
    if (this.isNotEmpty(val)) return val
    else if (defaultVal) return defaultVal
    else return ''
  },
  /**
   * 如果value为空，返回一个格格符
   * 使用 ridEmpty (val, defaultVal) 替换
   * @param value
   * @returns {*}
   */
  getNewValue (value) {
    if (this.isNotEmpty(value)) return value
    else return '..'
  },
  /*
  不确定是 普通类型 还是 对象类型 用这个方法比较是否相同
  注意： 不等于才返回 true
   */
  compare (arg0, arg1) {
    let sub0, sub1
    if (typeof arg0 === 'object') {
      sub0 = JSON.stringify(arg0)
      sub1 = JSON.stringify(arg1)
    } else {
      sub0 = arg0
      sub1 = arg1
    }
    if (sub0 === null || sub0 === undefined) sub0 = ''
    if (sub1 === null || sub1 === undefined) sub1 = ''
    if (sub0 !== sub1) return true
    else return false
  },
  /**
   * 把阿拉伯数字转成中文大写数字
   * trip组件中有使用
   * */
  numberConvert (num) {
    num = Number(num)
    let upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿']
    let length = String(num).length
    if (length === 1) {
      return upperCaseNumber[num]
    } else if (length === 2) {
      if (num === 10) {
        return upperCaseNumber[num]
      } else if (num > 10 && num < 20) {
        return '十' + upperCaseNumber[String(num).charAt(1)]
      } else {
        return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '')
      }
    }
  },
  getEditorHtml (content) {
    return '<div class="ql-editor" data-gramm="false" contenteditable="true" data-placeholder="Insert text here ...">' +
      content + '</div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div>'
  },
  getRichTextHtml (content) {
    return '<div class="ql-editor" data-gramm="false" contenteditable="true" data-placeholder="Insert text here ...">' +
      content + '</div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div>'
  },
  // 给一个dom节点添加一个class
  addClass (obj, cls) {
    let objClass = obj.className // 获取 class 内容.
    let blank = (objClass !== '') ? ' ' : ''// 判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
    let added = objClass + blank + cls // 组合原来的 class 和需要添加的 class.
    obj.className = added // 替换原来的 class.
  },
  // 移除一个dom节点的class
  removeClass (obj, cls) {
    let objClass = ' ' + obj.className + ' ' // 获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
    objClass = objClass.replace(/(\s+)/gi, ' ') // 将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
    let removed = objClass.replace(' ' + cls + ' ', ' ') // 在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
    removed = removed.replace(/(^\s+)|(\s+$)/g, '') // 去掉首尾空格. ex) 'bcd ' -> 'bcd'
    obj.className = removed // 替换原来的 class.
  },
  // 判断一个节点是否有一个某个class
  hasClass (obj, cls) {
    let objClass = obj.className // 获取 class 内容.
    let objClassLst = objClass.split(/\s+/) // 通过split空字符将cls转换成数组.
    let x = 0
    for (x in objClassLst) {
      if (objClassLst[x] === cls) { // 循环数组, 判断是否包含cls
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js